import React, { PropsWithChildren } from 'react';
import { ModalResolverProvider } from '@cp/shared/modal';
import { modalResolver } from './modalResolver';

export const AppModalsResolver: React.FC<PropsWithChildren> = (props) => (
  <ModalResolverProvider value={modalResolver}>{props.children}</ModalResolverProvider>
);
